export const testimonialsData = [
  {
    name: 'Laurie',
    text: 'I throughly enjoyed having Rod and Nate do my main bathroom gut renovation. They were attentive, skilled, & addressed all my concerns promptly and professionally. Rod will get to the bottom of all issues that may come up dealing with the other subs. I am very happy with my finished product!',
    color: 'bg-purple-500',
    rating: 5
  },
  {
    name: 'DeaAnn',
    text: "I love my new kitchen, it's so beautiful! I had a total kitchen remodel. They did the work while we were away on a mission. They were good to send us plans, and show us 3D images of what the kitchen was going to look like. We were so pleased when we got home. I really enjoyed working with Oak and Stone.",
    color: 'bg-green-500',
    rating: 5
  },
  {
    name: 'Valerie',
    text: 'Really loved working with these guys. They did a great job! I absolutely love my kitchen.',
    color: 'bg-orange-500',
    rating: 5
  },
  {
    name: 'Berk',
    text: 'Rodney and Nate are top notch guys. They built our kitchen and we love it.',
    color: 'bg-yellow-500',
    rating: 5
  },
  {
    name: 'Sonya',
    text: 'Very nice work Pleasant to work with.',
    color: 'bg-blue-500',
    rating: 5
  },
  {
    name: 'Whitney',
    text: 'Rod and his crew gave us the kitchen, laundry and updated living room we never thought possible! When we met Rod, we were impressed by his enthusiasm, passion and vision for our home. We gave him ideas and a layout that we thought we wanted. He took those plans and created the most functional space we could ask for! Every one of the sub contractors were kind, professional and people we felt confident with working on our home. I am so grateful for our new kitchen, laundry and living space!',
    color: 'bg-purple-500',
    rating: 5
  },
  {
    name: 'Michael',
    text: 'We hired Oak & Stone to finish our basement. Aside from a few slips in the timeline, the project went smoothly and their work was consistently top notch. We are delighted with the finished product!',
    color: 'bg-green-500',
    rating: 4
  },
  {
    name: 'Cindy',
    text: 'Beautiful custom cabinets and woodworking. Kitchen, Bathroom, anything looks luxurious.',
    color: 'bg-purple-500',
    rating: 5
  },
  {
    name: 'Nique',
    text: 'Let me start off with saying I have trust issues.. that being said Rod has been amazing to work with. He has drawn out every single detail and action. Not only that but he ensures that his crew is skilled, respectful and cleans up their mess as they go along. I am so excited for all of the work they are doing.',
    color: 'bg-orange-500',
    rating: 5
  },
  {
    name: 'Loralie',
    text: `Oak and Stone is wonderful! Rodney and Nate do perfectionist work. Whenever there is an unforeseen problem they come up with brilliant, inspired solutions. Rodney often says, "I'm here to make your (project) dreams come true." They keep their word and show up to work without you having to ask or wonder. If the schedule changes at all there is clear communication. Their response time is within a day, usually within an hour. They work hard and like to get any project done in a timely manner. They don't mind if you like to watch, make sure they're doing things to your liking, ask questions, and propose other or additional ideas along the way. They will use any materials you want, apply any ideas you have, and complete any projects you give them. They love what they do and they are always smiling! They created a retaining rock wall the entire length of our property while carefully avoiding existing trees. They installed some smaller brick retaining walls, stairs, and poured a concrete platform. They graded the yard to slope away from the house and to be more level, and then installed weed barrier and gravel before starting construction on my deck. They built us a 10x20' trex deck, on concrete pillars, including Rodney's signature stairs that have no raw edges! It's strong enough for my kids to sled down the stairs in the winter and my husband and I to enjoy a hammock that is anchored underneath it in the spring! They did my indoor wood flooring including split level entryway stairs, they put mud on and sanded my living/dining area walls, and they installed a jetted tub and tile floor in my master bathroom. Rodney told me I could call and ask him for advice or help with anything anytime and he is true to his word. I will continue to use them for all my future projects. They have the best quality of work, customer service and value for your money. I actually have a different guy in small claims court. For the same amount of money, Rodney and Nate did my jobs 10 times better! He didn't rip me off and he's happy to provide proof of his contractor's licence. In my opinion, it's an added plus that they don't smoke. I have and will continue to recommended Oak and Stone to everyone!`,
    color: 'bg-blue-500',
    rating: 5
  },
  {
    name: 'Sarah',
    text: `Amazing job you did on the remodel. It is spacious yet cozy! Love it, and thank you for making my parents dream come true!`,
    color: 'bg-red-500',
    rating: 5
  },
  {
    name: 'Scott',
    text: 'Rod and crew were very personable and professional. We did a complete kitchen remodel that included complete demolition, haul off, and rebuild, flooring, countertops, and cabinets. It turned out amazing.',
    color: 'bg-indigo-500',
    rating: 5
  },
  {
    name: 'Kayleen',
    text: 'I had a major remodel job upstairs and downstairs and these guys did an amazing job. They are trustworthy and excellent workmanship.',
    color: 'bg-teal-500',
    rating: 5
  },
  {
    name: 'Hali',
    text: 'We had them remodel our whole upstairs. They did an amazing job and were easy to work with',
    color: 'bg-pink-500',
    rating: 5
  },
  {
    name: 'Kerwin',
    text: 'They did an excellent job. They were very thorough and professional,and the crew was fun to work with, I would highly recommend oak & stone',
    color: 'bg-cyan-500',
    rating: 5
  },
  {
    name: 'Leilla',
    text: 'We built our home through oak and stone construction several years ago and have loved the work that the team provided. I was able to work with Rod to get my cabinets custom made and installed, and they are beautiful! All around, a great experience.',
    color: 'bg-emerald-500',
    rating: 5
  },
  {
    name: 'Reid',
    text: 'Highly recommended. Very professional and friendly. Thanks for giving us the kitchen of our dreams!',
    color: 'bg-amber-500',
    rating: 5
  },
  {
    name: 'Harmony',
    text: 'Rod and his crew did great. It was the second time we used them. We had them build cabinets while we installed them ourselves. They listened to the designs I specified and the cabinets are beautiful. They even helped me create a custom mid century hanging cabinet. There were a few hiccups but they fixed it until it was right.',
    color: 'bg-violet-500',
    rating: 5
  },
  {
    name: 'Scott',
    text: "Rod Ficklin is absolutely amazing. Rod has very advanced woodworking skills, as well as a terrific mind for creating solutions that work for any situation in a home. Rod is also very smart. And Rod also has great people skills. Rod is very patient when listening to customers explain the what they want done in their home. And Rod is also very patient with customers as he explains what he can do for them which will satisfy their needs and wants. Anyone who chooses to use Rod and his son-in-law Nate will have no regrets whatsoever and will be absolutely completely pleased with the work they do. And of course Rod and Nate stand behind all of their work. If you should ever have a problem down the road with cabinets or whatever work they do for a customer, Rod and Nate will take care of it, I'm sure. I was fortunate enough to have Rod work on a major remodel of my home in North Salt Lake, Utah. (This home was an Upscale home.) With Rod's abilities, we were able to remodel various cabinets, bathrooms, family rooms, doors, and windows in ways that were incredible. Rod came up with solutions and design ideas that were brilliant. Even though Nate didn't work on our North Salt Lake home, I was fortunate to get to know him on another endeavor. Nate is a great guy too! He is also very patient with people and always treats everyone exceptionally well. He too has great woodworking skills and has never-ending energy. Nate had a terrific personality and everyone enjoys being around him. In summary, in addition to Rod being a superb home builder, Rod Ficklin is one of the finest people I've ever known.",
    color: 'bg-slate-500',
    rating: 5
  },
  {
    name: 'James',
    text: 'Rodney was great to work with. The cabinets are beautiful and reasonably priced. They did a lot of other work for me too.',
    color: 'bg-rose-500',
    rating: 5
  },
  {
    name: 'Gayle',
    text: 'Rod and Nate at Oak & Stone are extremely professional, hard working, innovative and friendly and it was a pleasure to have them here working on our home. We had a complete kitchen remodel done along with painting other areas. The design for the kitchen gave us so much more cabinet space that we actually have empty space. I highly recommend them for any projects you might want done and I definitely will be hiring them again for our future remodeling. ROD & NATE ARE AWESOME !!!',
    color: 'bg-lime-500',
    rating: 5
  },
  {
    name: 'Rob',
    text: 'Good to work with and very responsive',
    color: 'bg-fuchsia-500',
    rating: 5
  },
  {
    name: 'Shawn',
    text: 'Rod and Oak & Stone Construction, LLC have been fantastic to work with over the years. I have used them on several projects. The work has always been completed in a timely matter, and even more important, the quality and care of the work is exceptional. I would highly recommend them for any project around the house!',
    color: 'bg-sky-500',
    rating: 5
  }
];
